import '@/assets/styles/index.css';

import { createApp } from 'vue';
import App from '@/App.vue';
import router from '@/router/index.js';
import store from '@/store/index.js';
import notify from '@/plugins/notify/index.js';

createApp(App)
  .use(store)
  .use(router)
  .use(notify)
  .mount('#app');
